export default {
  installments: "Quantidade de parcelas atualizadas",
  amount: "Crédito Adicional Disponível",
  quote_details: "CONTRATAR AGORA",
  first_due_date: "Próxima Data de Vencimento"
}